<password>
  <div class="password-title">パスワード再設定</div>
  <p>ご登録のメールアドレス宛に、パスワード再設定についてのメールをお送りします。</p>
  <form onsubmit="{ onSubmit }" class="password-form">
    <div class="form-group">
      <label class="form-label" for="mail">ご登録のメールアドレス</label>
      <input class="form-control" type="email" id="mail" name="mail" required>
    </div>
    <button class="password-btn btn btn-blue">パスワード再設定メールを送信</button>
    <div class="link-group">
      <a href="#login"><i class="fas fa-angle-double-left"></i>ログイン画面へ戻る</a>
    </div>
  </form>
  <script>
    import { serializeForm } from '@/common/utils/dom';
    export default {
      onSubmit(e) {
        e.preventDefault();
        const data = serializeForm(e.target);
        this.props.changeRequest(data);
      }
    };
  </script>
  <style type="postcss">
    .password-title {
      font-size: 1.5em;
    }

    .password-btn {
      width: 100%;
      margin-top: 16px;
    }

    .link-group {
      margin-top: 16px;
    }
  </style>
</password>